import React from 'react';
import { ReactComponent as Cancel } from '../../../Assets/Image/svg/cancel.svg';
import { useForm } from 'react-hook-form';
import { BtnPrimary } from '../../share/buttons/Btn';
import useFetch from '../../../Hooks/useFetch';

function AcceptIdea({ close, selectedIdea, getIdeasInfo }) {
	const confirmUserIdea = useFetch({
		method: 'POST',
		url: `BootCampIdeasService/${selectedIdea?.id}/confirmUserIdea`,
		noHeader: false,
		trigger: false,
		caller: getIdeasInfo,
	});
	return (
		<div className='AddnewsupportTicket relative'>
			<button
				onClick={() => close(false)}
				className='AddnewsupportTicket-cancel absolute  '
			>
				<div>
					<Cancel />
				</div>
			</button>
			<h3 className=' text-[#77498F] font-bold text-[2rem] leading-[3.2rem] text-center'>
				تایید ایده
			</h3>
			<div className=' grid grid-cols-[1fr]  gap-y-[1.5rem] items-center justify-start'>
				<div className='flex gap-x-4'>
					<span className=' text-[#212121E5] font-bold text-[1.6rem] '>
						نام ایده:
					</span>

					<p className=' text-[#212121E5] text-[1.6rem]'>
						{selectedIdea.idea_name}
					</p>
				</div>
				<div className='flex gap-x-4'>
					<span className=' text-[#212121E5] font-bold text-[1.6rem] '>
						نام ایده پرداز:
					</span>
					<p className=' text-[#212121E5] text-[1.6rem]'>
						{selectedIdea.user}
					</p>
				</div>
				<div>
					<span className=' text-[#212121E5] font-bold text-[1.6rem]  mb-[1rem]'>
						شرح ایده:
					</span>
					<p className=' text-[#212121E5] text-[1.6rem] leading-[2.8rem]'>
						{selectedIdea.idea_description}
					</p>
				</div>
			</div>
			<div className=' text-left mt-[3rem]'>
				<BtnPrimary
					className='py-[20px] px-[25px] '
					text='تایید ایده'
					onClick={() => {
						confirmUserIdea.reFetch();
						close(false);
					}}
				/>
			</div>
		</div>
	);
}

export default AcceptIdea;

{
	/* <Inputs
            register={{
              required: {
                value: true,
                message: "Enter Name",
              },
            }}
            type="text"
            name="name"
            full={true}
            control={control}
            placeholder=""
            className="border-[#9C5FA436] h-[4.4rem] w-full bg-white-dark placeholder-gray  text-[1.6rem] leading-[3.2rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem]"
          /> */
}

{
	/* <Inputs
            register={{
              required: {
                value: true,
                message: "Enter Name",
              },
            }}
            type="text"
            name="name"
            full={true}
            control={control}
            placeholder=""
            className="border-[#9C5FA436] h-[4.4rem] w-full bg-white-dark placeholder-gray  text-[1.6rem] leading-[3.2rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem]"
          /> */
}
{
	/* <textarea
            id="firstName"
            {...register("firstName", { required: true, maxLength: 20 })}
            className=" border border-[#9C5FA436] border-solid resize-none focus:outline-none w-full h-[20.7em] rounded-[1.5rem] text-[1.6rem] leading-[3.2rem] bg-transparent px-[1rem] pr-[1.4rem] overflow-auto custom-scrollbars"
          ></textarea>
          {errors.firstName && (
            <span className="input__message block mt-1 text-[1.2rem] text-red-600">
              شرح ایده
            </span>
          )} */
}

{
	/* <p className=" text-[#B00020] text-[1.2rem] leading-[2.4rem] font-normal">
            *در صورت تایید ایده قادر به حذف آن نخواهید بود !
          </p> */
}
